import * as Atom from "effect/reactivity/Atom";
/** The atom owns a subscription only. Session and native resources belong to composition. */
export function makeSessionAtom(session) {
    return Atom.make((context) => {
        context.addFinalizer(session.subscribe(() => context.setSelf(session.getSnapshot())));
        // Read after subscribing so an update at acquisition cannot leave a stale initial value.
        return session.getSnapshot();
    });
}
